const messages = {
  title: 'Interna greška',
  description: 'Podaci za ovu stranicu ne mogu biti pravilno učitani.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
